import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext, useEffect, useState } from "react";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import AutoComplete, { AutoCompleteOption } from "../common/AutoComplete";
import { nameof } from "../common/ObjectUtils";
import MonySymbolsComponets from "../common/MonySymbolsComponents";
import FormInput from "../common/FormInput";
import dayjs from "dayjs";
import * as Yup from "yup";
import { ContextOperation } from "../../context/OperationContext";
import { useForm } from "react-hook-form";
import { VehicleInspection } from "./Types";
import VehicleInspectionService from "./sevices/VehicleInspection.action";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useFormik } from "formik";
import { DateTimePicker } from "@mui/x-date-pickers";
interface Props {
  open: boolean;
  onClose: () => void;
  vehicleId:number;
  pageState:any;
  setRefresh: () => void;
}
const CreateVehicleInspection =(props:Props) =>{
  const {setLoading} = useContext(ContextOperation);
  const snackbar = useSnackbar();
  const t = useOperationTranslation();
  const {tenant} = useContext(ContextOperation);
  const id = props.vehicleId;
  var reg = /^[0-9\b]+$/;
  const [count, setCount] = useState<number>(0);

  let validateForm = {
    kmInspection: Yup.number()
      .required(t("vehicleInspection.crate.validationForm.kmInspectionRequired"))
      .typeError(t("vehicleInspection.validateForm.kmTypeError")),
      inspectionDate: Yup.date()
      .required(t("vehicleInspection.crate.validationForm.inspectionDateRequired"))
      .typeError(t("vehicleInspection.crate.validationForm.inspectionDateRequired")),
  };

  if (props.pageState.length > 0) {
    validateForm = {
      kmInspection: Yup.number()
        .required(t("vehicleInspection.crate.validationForm.kmInspectionRequired"))
        .typeError(t("vehicleInspection.validateForm.kmTypeError"))
        .min(
          props.pageState[0].kmInspection + 1,
          t("vehicleInspection.crate.validationForm.kmInspectionError")
        ),

        inspectionDate: Yup.date()
        .required(t("vehicleInspection.crate.validationForm.inspectionDateRequired"))
        .typeError(t("vehicleInspection.crate.validationForm.inspectionDateRequired"))
        .test(
          "DOB",
          t("vehicleInspection.validateForm.greaterDate"),
          (inspectionDate) => {
           
            return (
             dayjs(props.pageState[0].inspectionDate).diff(dayjs(inspectionDate)) <
              0) 
          }
        ) .test(
          "DOB",
          t("vehicleInspection.validateForm.greaterthanCurrentDate"),
          (inspectionDate) => {
           
            return (
              (dayjs(inspectionDate)).diff(dayjs(new Date())) < 0 )
          }
        ),
    };
  }

  const ValidateForm = Yup.object().shape(validateForm);
  const formik = useFormik({
    initialValues: {
      inspectionDate:'',
      kmInspection:""
    },

    validationSchema: ValidateForm,
    onSubmit: (values) => {
      createEditMaintenanceCar(values);
      //setOpenAddDialog(false);
    },
  });
    const form = useForm<VehicleInspection.CreateVehicle>({
        defaultValues:{
        },
       });
    const createEditMaintenanceCar =(values:any)=>{  
      setLoading(true);
        let veficleObject ={
          vehicleId:props.vehicleId,
          kmInspection: values.kmInspection,
          inspectionDate:values.inspectionDate
        }
        VehicleInspectionService.post.createVehicle(tenant,veficleObject).then((response:any)=>{
         props.onClose();
         formik.resetForm();
         setLoading(false);
          snackbar.show("success",t("vehicleInspection.crate.successMessage"));
          props.setRefresh();
          
        },
        (error: any) => {
          props.onClose();
          formik.resetForm();
        
         if (error.response.status == 409) {
           snackbar.show("error", t("vehicleInspection.crate.create409Error"));
         }
       }
     );
     // }
      setLoading(false)
    }


    const onClose = () =>{
      props.onClose();
      formik.resetForm()
    }

    return (
  
      <Mui.Dialog open={props.open} onClose={onClose} fullWidth maxWidth="md">
              
           <form id="submit1"  onSubmit={formik.handleSubmit}>
     <Mui.DialogTitle>
       <Mui.Grid container alignItems="center">
         <Mui.Grid item xs="auto">
           <Mui.Typography variant="h6">
             {t("vehicleInspection.crate.title")}
           </Mui.Typography>
         </Mui.Grid>
         <Mui.Grid item xs="auto" marginLeft="auto">
           <Mui.IconButton onClick={onClose}>
             <MuiIcons.Close />
           </Mui.IconButton>
         </Mui.Grid>
       </Mui.Grid>
     </Mui.DialogTitle>
     <Mui.DialogContent>
      
         <Mui.Grid container spacing="16px" p={2}>
           <Mui.Grid xs item>
           <DateTimePicker
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "inspectionDate",
                          dayjs.utc(e).format("YYYY-MM-DDTHH:mm:ssZ")
                        );
                      }}
                      mask={"__/__/____ __:__"}
                      inputFormat={"DD/MM/YYYY HH:mm"}
                      // disableFuture
                      maxDateTime={new Date()}
                      label={t("vehicleInspection.crate.inspectionDate")}
                      ampm={false}
                      value={formik.values.inspectionDate}
                      renderInput={(params) => (
                        <>
                          <Mui.TextField
                            variant="standard"
                           
                            fullWidth
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                             // placeholder: t("carMaintenance.createAndEdit.dateInput"),
                            }}
                            name="inspectionDate"
                            onBlur={formik.handleBlur}
                            error={
                              (formik.touched.inspectionDate && Boolean(formik.errors.inspectionDate))
                            }
                            helperText={
                              formik.touched.inspectionDate && formik.errors.inspectionDate 
                            }
                          />
                        </>
                      )}
                    />
           </Mui.Grid>

           <Mui.Grid xs item>
             <Mui.Box>
             <Mui.TextField
                    fullWidth
                    id="kmInspection"
                    name="kmInspection"
                    type="text"
                    label={t("vehicleInspection.crate.kmInspection")}
                    value={formik.values.kmInspection}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      Boolean(formik.errors.kmInspection) && formik.touched.kmInspection
                    }
                    helperText={
                              (formik.touched.kmInspection && formik.errors.kmInspection )
                  
                      
                    }
                  />
             </Mui.Box>
           </Mui.Grid>
         </Mui.Grid>
      
     </Mui.DialogContent>
     <Mui.DialogActions>
       <Mui.Grid container justifyContent="end" spacing="16px" p={2}>
         <Mui.Grid item xs="auto">
           <Mui.Button variant="outlined" size="medium" onClick={onClose}>
             {t(
               "vehicleEquipmentAssociation.dialogs.editAcriss.actions.cancel"
             )}
           </Mui.Button>
         </Mui.Grid>
         <Mui.Grid item xs="auto">
           <Mui.Button type="submit" size="medium">
             {t("actionButtons.save")}
           </Mui.Button>
         </Mui.Grid>
       </Mui.Grid>
     </Mui.DialogActions>
     </form>
           </Mui.Dialog>
      );
}
export default CreateVehicleInspection;